import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import api from "../lib/api";
import { sanitizePage } from "../lib/sanitizeContent";
import { useSite } from "../context/SiteContext";
import BlocksRenderer from "../components/blocks/Blocks";
import { PageLoader, SyncPending } from "../components/Loaders";

const HomePage = () => {
  const { meta } = useSite();
  const [page, setPage] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    api
      .get("/home")
      .then(({ data }) => {
        setPage(sanitizePage(data));
        setStatus("ok");
      })
      .catch((e) => setStatus(e?.response?.status === 404 ? "pending" : "error"));
  }, []);

  if (status === "loading") return <PageLoader />;
  if (status === "pending") return <SyncPending />;
  if (!page) return <SyncPending />;

  const cards = (meta?.nav || []).filter((n) => !n.is_home);

  return (
    <div>
      <section className="pillet-hatch border-b border-pillet-forest">
        <div className="max-w-4xl mx-auto px-5 py-20 sm:py-28 pillet-reveal">
          <p className="font-heading uppercase tracking-[0.3em] text-pillet-sage text-xs mb-5">
            Portail interactif
          </p>
          <h1 className="font-heading font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.05]">
            {page.title}
          </h1>
          <div className="w-24 h-1 bg-pillet-sage mt-8" />
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-5 py-12">
        <BlocksRenderer nodes={page.blocks} />
      </section>

      {cards.length > 0 && (
        <section className="max-w-5xl mx-auto px-5 pb-8">
          <p className="font-heading uppercase tracking-[0.25em] text-pillet-muted text-xs mb-6">
            Livrables
          </p>
          <div className="grid sm:grid-cols-2 gap-5">
            {cards.map((c, i) => (
              <Link
                key={c.slug}
                to={`/p/${c.slug}`}
                data-testid={`home-card-${c.slug}`}
                className="group pillet-card p-6 flex items-start justify-between gap-4 hover:bg-pillet-forest/50 transition-colors pillet-reveal"
                style={{ animationDelay: `${i * 80}ms` }}
              >
                <div>
                  <span className="font-heading text-pillet-sage/60 text-sm">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="font-heading font-bold text-lg text-white uppercase tracking-wide mt-1 group-hover:text-pillet-sage transition-colors">
                    {c.title}
                  </h3>
                </div>
                <ArrowUpRight className="text-pillet-sage shrink-0 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
              </Link>
            ))}
          </div>
        </section>
      )}
    </div>
  );
};

export default HomePage;
